/**
 * @file 入口文件
 * @author hardylin <hardylin@tencent.com>
 */
import './styles/custom-properties.css'
import './styles/index.css'
import './styles/animate.css'

import { version } from '../package.json'
import config from './scripts/config'
import ActionSheet from './components/actionsheet'
import Icon from './components/icon/icon'
import Image from './components/image/image'
import Load from './components/load/load'
import Popup from './components/popup'
import Scroll from './components/scroll/scroll'
import Swiper from './components/swiper/index'
import SwiperImage from './components/swiper/image'
import Switch from './components/switch/index'
import Toast from './components/toast/toast'
import Waterfall from './components/waterfall/index'

/**
 * Vue 插件安装方法
 * @param {Object} Vue - Vue 类
 */
function install(Vue) {
    
    // #region 自定义组件
    Vue.component(Icon.name, Icon)
    Vue.component(Image.name, Image)
    Vue.component(Load.name, Load)
    Vue.component(Scroll.name, Scroll)
    Vue.component(Swiper.name, Swiper)
    Vue.component(Switch.name, Switch)
    Vue.component(Waterfall.name, Waterfall)
    // #endregion
    
    // #region 实例方法
    Vue.prototype.$actionSheet = ActionSheet
    Vue.prototype.$popup = Popup
    Vue.prototype.$swiperImage = SwiperImage
    Vue.prototype.$toast = Toast
    // #endregion
    
}

// #region 自动安装
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}
// #endregion

export default {
    install,
    version,
    config,
}

export {
    version,
    config,

    ActionSheet,
    Icon,
    Image,
    Load,
    Popup,
    Scroll,
    Swiper,
    SwiperImage,
    Switch,
    Toast,
}